import { render, staticRenderFns } from "./My_Order.vue?vue&type=template&id=24f42dae"
import script from "./My_Order.vue?vue&type=script&lang=js"
export * from "./My_Order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports